import axios from 'axios';

export default function (endpoint) {
  async function get(user) {
    return (
      await axios.get(endpoint, {
        headers: {
          jwt: user.jwt,
        },
      })
    ).data;
  }

  async function create(user, item) {
    return (
      await axios.post(endpoint, item, {
        headers: {
          jwt: user.jwt,
        },
      })
    ).data;
  }

  async function update(user, item) {
    return (
      await axios.put(endpoint, item, {
        headers: {
          jwt: user.jwt,
        },
      })
    ).data;
  }

  async function remove(user, { _id }) {
    return (
      await axios.delete(endpoint, {
        headers: {
          jwt: user.jwt,
        },
        params: {
          _id,
        },
      })
    ).data;
  }

  return {
    get, create, update, remove,
  };
}
